<div class="main-container" style="height: 100%;">
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [disableClose]="mobileQuery.matches" [(opened)]="opened">
            <app-sidebar></app-sidebar>
        </mat-sidenav>

        <mat-sidenav-content class="page-wrapper">
            <mat-toolbar class="topbar telative colorBack">
                <div>
                    <button id="snavButton" mat-mini-fab (click)="snav.toggle()" value="sidebarclosed" class="snav" *ngIf="layaoutExit">
                        <mat-icon *ngIf="!opened">menu</mat-icon>
                        <mat-icon *ngIf="opened">menu_open</mat-icon>
                    </button>
                </div>

                <div class="pg-topbar-title">
                    <b class="letterUnah">Posgrado UNAH</b>
                </div>

                <span fxFlex></span>

                <app-header class="floatRight"></app-header>
            </mat-toolbar>
            <div class="page-content">
                <router-outlet>
                    <app-spinner></app-spinner>
                </router-outlet>

            </div>

        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
</div>